export default __webpack_public_path__ + "603a4f4ff442970334881a1254196430.jpg";